import { SettingsProperty } from 'editor/src/store/editor/types';
import { RootState } from 'editor/src/store/index';

const getSettingsValue = <T extends SettingsProperty>(state: RootState, property: T) => state.editor.settings[property];

export default getSettingsValue;
